module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-1"
  }, [_c('ul', {
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/color-spiral"
    }
  }, [_c('a', [_vm._v("1")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/spiral"
    }
  }, [_c('a', [_vm._v("2")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/canvas"
    }
  }, [_c('a', [_vm._v("3")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/tunnel"
    }
  }, [_c('a', [_vm._v("4")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/sunflower"
    }
  }, [_c('a', [_vm._v("5")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/rainbow"
    }
  }, [_c('a', [_vm._v("6")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-23784901"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenu.vue
// module id = 122
// module chunks = 1